/* PLP helpers for USF product cards (GA4) + Prestige filter drawer.
   Kept outside assets/usf.* (shopifyignored / USF-managed).

   Filters closed by default (like US): keep inverted binding
     'usf-collapsed': !collapsed && !usf.isMobile
   (Develop helpers used to flip this to !!collapsed → panels stay open.)

   .usf-refineby footer: Prestige CSS expects it INSIDE .usf-facets as last flex
   child (space-between). Inject there only after .usf-facets__body exists.
   No document MutationObserver (that previously froze Vue on the loader). */
function getCurrentVariantName(product) {
  return (product.options && product.options[0] && product.options[0].values)
    ? product.options[0].values[0]
    : '';
}

function getFirstAvailVariantNameIfNotSoldOut(product) {
  if (product.variants && product.options && product.options[0] !== undefined && product.options[0].values) {
    for (const variant of product.variants) {
      if (variant.available && variant.available > 0) {
        if (variant.options) {
          return product.options[0].values[variant.options[0]];
        }
      }
    }
    return product.options[0].values[0];
  }
  return '';
}

function getCurrentVariantSku(product) {
  var result = '';
  var matchFound = false;
  if (!product || !product.variants) return result;
  product.variants.forEach(function (variant) {
    if (!matchFound && variant.available) {
      result = variant.sku;
      matchFound = true;
    }
  });
  return result;
}

(function usfPlpHelpers() {
  var FILTER_TAG_RE = /<usf-filter :facet="f" :key="f\.id" v-for="f in facets"><\/usf-filter>/g;
  var FILTER_TAG_FIXED =
    '<usf-filter :facet="f" :key="f.id" :is-collapsed="collapsed[f.id]" @onToggleFilter="onToggleFilter" @onToggleAllFilters="onToggleAllFilters" v-for="f in facets"></usf-filter>';
  /* Force US closed-by-default binding (do NOT flip to !!collapsed). */
  var COLLAPSED_RE = /'usf-collapsed':\s*!!?collapsed\s*&&\s*!usf\.isMobile/g;
  var COLLAPSED_US = "'usf-collapsed': !collapsed && !usf.isMobile";

  function patchTemplates(templates) {
    if (!templates || templates.__usfPlpFiltersPatched) return templates;
    if (typeof templates.filters === 'string' && FILTER_TAG_RE.test(templates.filters)) {
      FILTER_TAG_RE.lastIndex = 0;
      templates.filters = templates.filters.replace(FILTER_TAG_RE, FILTER_TAG_FIXED);
    }
    if (typeof templates.filter === 'string') {
      COLLAPSED_RE.lastIndex = 0;
      if (COLLAPSED_RE.test(templates.filter)) {
        COLLAPSED_RE.lastIndex = 0;
        templates.filter = templates.filter.replace(COLLAPSED_RE, COLLAPSED_US);
      }
    }
    templates.__usfPlpFiltersPatched = true;
    return templates;
  }

  /* After Vue compiled with !!collapsed, sync class to US closed look using aria-expanded. */
  function syncCollapsedClasses() {
    if (window.usf && usf.isMobile) return;
    var facets = document.querySelectorAll(
      '#usf-sf-filter-tree .usf-facets__body > .usf-facet, .CollectionFilters .usf-facets__body > .usf-facet'
    );
    for (var i = 0; i < facets.length; i++) {
      var facet = facets[i];
      var btn =
        facet.querySelector('.usf-clear .usf-label') ||
        facet.querySelector('.usf-title .usf-label');
      if (!btn) continue;
      var expanded = btn.getAttribute('aria-expanded');
      /* US inverted: collapsed=false → aria-expanded=true → class usf-collapsed (closed). */
      if (expanded === 'true') facet.classList.add('usf-collapsed');
      else if (expanded === 'false') facet.classList.remove('usf-collapsed');
    }
  }

  var APPLY_LABELS = {
    it: 'Applica',
    en: 'Apply',
    de: 'Anwenden',
    fr: 'Appliquer',
    es: 'Aplicar'
  };

  function applyLabel() {
    var loc =
      (window.usf && usf.platform && usf.platform.locale) ||
      window._usfLocale ||
      'en';
    loc = String(loc).slice(0, 2).toLowerCase();
    return APPLY_LABELS[loc] || APPLY_LABELS.en;
  }

  function clearAllLabel() {
    try {
      return (usf.settings && usf.settings.translation && usf.settings.translation.clearAll) || 'Clear all';
    } catch (e) {
      return 'Clear all';
    }
  }

  function clearAllAria() {
    try {
      return (usf.settings && usf.settings.translation && usf.settings.translation.clearAllFilters) || clearAllLabel();
    } catch (e) {
      return clearAllLabel();
    }
  }

  function refinebyHtml() {
    return (
      '<div class="usf-refineby" data-usf-plp-refineby="1">' +
        '<div class="Drawer__Footer">' +
          '<div class="ButtonGroup">' +
            '<button type="button" class="Button btn btn--default button-close-drawer link--highlight" data-action="apply-tags" data-usf-plp-apply="1">' +
              applyLabel() +
            '</button>' +
            '<button type="button" class="Button--underline-span link--highlight" data-usf-plp-clear="1" aria-label="' +
              clearAllAria().replace(/"/g, '&quot;') +
            '">' +
              '<span>' + clearAllLabel() + '</span>' +
            '</button>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  function closeDrawerSafe() {
    if (typeof window.closeDrawer === 'function') {
      try {
        window.closeDrawer();
        return;
      } catch (e) { /* fall through */ }
    }
    var el =
      document.querySelector('#usf-collection-filter-drawer .Drawer__Close') ||
      document.querySelector('.CollectionFilters .Drawer__Close') ||
      document.querySelector('.Drawer__Close');
    if (el) el.click();
  }

  function findFiltersVm() {
    if (!window.usf || !usf.app) return null;
    var found = null;
    (function walk(v, d) {
      if (!v || d > 14 || found) return;
      if (v.$options && v.$options._componentTag === 'usf-filters') found = v;
      else if (typeof v.removeAllFacetFilters === 'function') found = v;
      (v.$children || []).forEach(function (c) {
        walk(c, d + 1);
      });
    })(usf.app, 0);
    return found;
  }

  function wireRefineby(el) {
    if (!el || el.__usfPlpWired) return;
    el.__usfPlpWired = true;
    var applyBtn = el.querySelector('[data-usf-plp-apply]');
    var clearBtn = el.querySelector('[data-usf-plp-clear]');
    if (applyBtn) {
      applyBtn.addEventListener('click', function (ev) {
        ev.preventDefault();
        closeDrawerSafe();
      });
    }
    if (clearBtn) {
      clearBtn.addEventListener('click', function (ev) {
        ev.preventDefault();
        var vm = findFiltersVm();
        if (vm && typeof vm.removeAllFacetFilters === 'function') {
          vm.removeAllFacetFilters();
        }
      });
    }
  }

  function injectRefineby() {
    if (window.usf && usf.isMobile) return;

    /* Prestige CSS: refineby must be last child of .usf-facets (flex column + space-between).
       #usf-sf-filter-tree is height 100vh — siblings outside are clipped/invisible. */
    var facetsRoots = document.querySelectorAll(
      '#usf-sf-filter-tree .usf-facets, .CollectionFilters #usf-sf-filter-tree .usf-facets'
    );
    for (var i = 0; i < facetsRoots.length; i++) {
      var root = facetsRoots[i];
      if (!root.querySelector('.usf-facets__body')) continue;

      var existing = root.querySelector('[data-usf-plp-refineby]');
      if (existing) {
        /* Keep as last child */
        if (root.lastElementChild !== existing) root.appendChild(existing);
        wireRefineby(existing);
        continue;
      }

      var wrap = document.createElement('div');
      wrap.innerHTML = refinebyHtml();
      var node = wrap.firstChild;
      root.appendChild(node);
      wireRefineby(node);
    }

    syncCollapsedClasses();
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    var delays = [0, 100, 400, 1000];
    for (var i = 0; i < delays.length; i++) {
      (function (ms, last) {
        setTimeout(function () {
          try {
            injectRefineby();
          } catch (e) { /* ignore */ }
          if (last) scheduled = false;
        }, ms);
      })(delays[i], i === delays.length - 1);
    }
  }

  function onFacetTitleClick(ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    if (!t.closest('.usf-facets__body .usf-title, .usf-facets__body .usf-label')) return;
    setTimeout(syncCollapsedClasses, 0);
    setTimeout(syncCollapsedClasses, 50);
  }

  function onReady() {
    schedule();
    document.addEventListener('click', onFacetTitleClick, true);
    document.addEventListener(
      'click',
      function (ev) {
        var t = ev.target;
        if (!t || !t.closest) return;
        if (
          t.closest(
            '.CollectionToolbar__Item--filter, [data-drawer-id*="filter"], #usf-collection-filter-drawer, .CollectionFilters'
          )
        ) {
          schedule();
        }
      },
      true
    );
    if (usf.event && typeof usf.event.add === 'function') {
      usf.event.add('sr_updated', schedule);
      usf.event.add('init', schedule);
    }
  }

  function install() {
    if (!window.usf) {
      setTimeout(install, 0);
      return;
    }

    if (usf.templates) {
      patchTemplates(usf.templates);
    } else {
      var value;
      Object.defineProperty(usf, 'templates', {
        configurable: true,
        enumerable: true,
        get: function () {
          return value;
        },
        set: function (next) {
          value = patchTemplates(next);
        }
      });
    }

    if (usf.event && typeof usf.event.add === 'function') {
      usf.event.add('init', onReady);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady);
    } else {
      onReady();
    }
  }

  install();
})();
